export default "__VITE_ASSET__CBWi5hW1__"